import { render, staticRenderFns } from "./SwitchAvailability.vue?vue&type=template&id=4b450f3a&scoped=true"
import script from "./switchAvailability.ts?vue&type=script&lang=ts&external"
export * from "./switchAvailability.ts?vue&type=script&lang=ts&external"
import style0 from "./SwitchAvailability.vue?vue&type=style&index=0&id=4b450f3a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b450f3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/r1/a/_stemdoplatform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b450f3a')) {
      api.createRecord('4b450f3a', component.options)
    } else {
      api.reload('4b450f3a', component.options)
    }
    module.hot.accept("./SwitchAvailability.vue?vue&type=template&id=4b450f3a&scoped=true", function () {
      api.rerender('4b450f3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/app/sections/shared/explore/top-filter/filter/switch-availability/SwitchAvailability.vue"
export default component.exports